
<div  class="modal-header"  *ngIf="!loading && reservation && reservation.reser">
   <div  class="header-actions">
     <span class="header-title">
          {{ reservation.cinema.liv_ville }} - {{ reservation.film.nom_film }}
          <i class="bi bi-circle-fill" [ngClass]="getStatusClass(reservation.reser.etat_req)"></i>
    </span>
     <div class="form-group version-group">
       <label class="bold_text">{{ 'editReservationModal.form.versionsLabel' | translate }}</label>
       <div class="display-flex">
         <div *ngFor="let version of versions">
           <div class="form-check" style="margin-right: 5px">
             <input type="checkbox" class="form-check-input"
                    [id]="version.id_ver"
                    [value]="version.id_ver"
                    (change)="toggleVersion(version)"
                    [checked]="version.checked" />
             <label class="form-check-label" [for]="version">{{ version.version_label }}</label>
           </div>
         </div>
       </div>
     </div>
   </div>
   <div class="prog-date">
        <label class="header-date-label">{{ 'editReservationModal.form.dateLabel' | translate }}</label>
        <input
          class="form-control datepicker-input"
          [formControl]="dateDebutControl"
          ngbDatepicker
          #d1="ngbDatepicker"
          (click)="d1.toggle()"
          [firstDayOfWeek]="3"
        /> -
        <input
          class="form-control datepicker-input"
          [formControl]="dateFinControl"
          ngbDatepicker
          #d2="ngbDatepicker"
          (click)="d2.toggle()"
          [firstDayOfWeek]="3"
        />
        <button type="button" class="close" (click)="closeModal()">{{ 'editReservationModal.modalHeader.closeButton' | translate }}</button>
      </div>
</div>
<div  class="modal-header"  *ngIf="loading">
  <div class="prog-date">
    <button type="button" class="close" (click)="closeModal()">{{ 'editReservationModal.modalHeader.closeButton' | translate }}</button>
  </div>
</div>

<div class="modal-body">
  <div *ngIf="!loading">
    <div class="row">
      <div class="col-4">
        <div class="display-flex" style="">
          <div class="section-title">
            <h4>{{ 'editReservationModal.transport.title' | translate }}</h4>
          </div>
          <div class="created-transport" *ngIf="createdTransport > 0">
            <span class="created-value">{{ createdTransport }}</span>
            <span class="created-label">{{ 'editReservationModal.transport.created' | translate }}</span>
          </div>
          <div class="process-transport" *ngIf="processTransport > 0">
            <span class="process-value">{{ processTransport }}</span>
            <span class="process-label">{{ 'editReservationModal.transport.inProgress' | translate }}</span>
          </div>
          <div class="send-transport" *ngIf="sendTransport > 0">
            <span class="send-value">{{ sendTransport }}</span>
            <span class="send-label">{{ 'editReservationModal.transport.sent' | translate }}</span>
          </div>
        </div>
        @if (reservation) {
          @if ((reservation.list_transport | keyvalue).length > 0) {
            <div class="form-group film_text">
                <div *ngFor="let transport of reservation?.list_transport | keyvalue">
                  <div *ngIf="transport.value.req.type_transport === REQ_DIGITAL_SEND &&
                    transport.value.textStatus[0] === '100%' &&
                    transport.value.req.etat === RECEIVED_SITE &&
                    transport.value.req.presta_dest === CINEGO">
                    <div class="progress">
                      <div class="progress-bar bg-blue" role="progressbar"
                          [style.width.%]="100"
                          aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                        100%
                      </div>
                    </div>
                    <div class="text-success">
                      {{ 'editReservationModal.transport.transfertTermine' | translate }} {{ transport.value.textStatus[1] }}
                    </div>
                  </div>
                  <div *ngIf="transport.value.req.type_transport === REQ_DIGITAL_SEND &&
                    transport.value.textStatus[0] !== '' && transport.value.req.etat !== CREATED">
                    {{ transport.value.req.text_req | translate }} ({{ transport.value.req.presta_dest_name }}) - {{ transport.value.textStatus[0] }}
                  </div>
                  <div *ngIf="transport.value.req.type_transport === REQ_DUPLIC_SEND &&
                    transport.value.textStatus[0] !== '' && transport.value.req.etat !== CREATED">
                    {{ transport.value.req.text_req | translate }} ({{ transport.value.req.presta_dest_name }}) - {{ transport.value.textStatus[0] }}
                  </div>
                  <div *ngIf="transport.value.req.presta_dest !== CINEGO && transport.value.req.etat !== CREATED">
                    {{ 'editReservationModal.transport.changeStatus' | translate }}
                    <select (change)="updateTransportStatus($event, transport.value.req.id_transport)">
                      <option *ngFor="let status of transportStatuses"
                              [selected]="transport.value.req.etat === status.id"  [value]="status.id">
                        {{ status.label | translate }}
                      </option>
                    </select>
                  </div>
                  <div class="form-check-group" *ngIf="transport.value.req.etat == CREATED">
                    <div class="display-flex"  *ngIf="(this.reservation?.transport?.allowCS || this.reservation?.transport?.allowGC)">
                      <div class="form-check">
                        <input
                          type="radio"
                          id="transport_electronique"
                          name="transportType"
                          value="3"
                          class="form-check-input"
                          (change)="updateTransportType($event, transport.value.req.id_transport, transport.value.req.id_pkg)"
                          [checked]="transport.value.req.type_transport === 3" />
                        <label for="transport_electronique" class="form-check-label">{{ 'editReservationModal.transport.electronic' | translate }}</label>
                      </div>
                      <div *ngIf="this.reservation?.transport">
                        <select id="selectedCinema" class="form-control input-style"
                                (change)="updateTransportType($event, transport.value.req.id_transport, transport.value.req.id_pkg, true)">
                          <option  [selected]="transport.value.req.presta_dest === cinego" *ngIf="this.reservation?.transport?.allowCS" [value]="cinego">{{ 'editReservationModal.transport.cinegoStock' | translate }}</option>
                          <option  [selected]="transport.value.req.presta_dest === gc"  *ngIf="this.reservation?.transport?.allowGC" [value]="gc">{{ 'editReservationModal.transport.globecast' | translate }}</option>
                          <option  [selected]="transport.value.req.presta_dest === gc_abonnes"  *ngIf="this.reservation?.transport?.gc_abonnes" [value]="gc_abonnes">{{ 'editReservationModal.transport.globecastAbonnes' | translate }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-check">
                      <input
                        type="radio"
                        id="transport_disque_dur"
                        name="transportType"
                        value="1"
                        class="form-check-input"
                        (change)="updateTransportType($event, transport.value.req.id_transport, transport.value.req.id_pkg)"
                        [checked]="transport.value.req.type_transport === 1" />
                      <label for="transport_disque_dur" class="form-check-label">{{ 'editReservationModal.transport.hardDisk' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input
                        type="radio"
                        id="transport_ne_pas_envoyer"
                        name="transportType"
                        value="0"
                        class="form-check-input"
                        (change)="updateTransportType($event, transport.value.req.id_transport, transport.value.req.id_pkg)"
                        [checked]="transport.value.req.type_transport === 0" />
                      <label for="transport_ne_pas_envoyer" class="form-check-label">{{ 'editReservationModal.transport.doNotSend' | translate }}</label>
                    </div>
                    <button class="btn btn-primary validate-btn validate-transport-btn"
                            *ngIf="transport.value.req.type_transport === 3 || transport.value.req.type_transport === 1"
                    (click)="validateTransport(transport.value.req.id_transport)">{{ 'editReservationModal.transport.validate' | translate }}</button>
                  </div>
                </div>
            </div>
          } @else {
              <div class="form-check">
                <input
                  type="radio"
                  id="transport_ne_pas_envoyer"
                  name="transportType"
                  value="0"
                  class="form-check-input"
                  checked="true"
                  [disabled]="true">
                <label for="transport_ne_pas_envoyer" class="form-check-label">{{ 'editReservationModal.transport.doNotSend' | translate }}</label>
              </div>
            }
          }

         
      </div>
      <div class="col">
        <form [formGroup]="contractForm" id="film_group_form" (ngSubmit)="updateContract()">
          <div class="section-title">
            <h4>{{ 'editReservationModal.form.contract_title' | translate }}</h4>
            <ng-container *ngIf="hasComments(); else addIcon">
              <i class="bi bi-chat-left-dots-fill text-info btn" (click)="openCommentModal()" title="{{ 'tooltip.existingComment' | translate }}"></i>
            </ng-container>
            <ng-template #addIcon>
              <i class="bi bi-plus-circle text-info btn" (click)="openCommentModal()" title="{{ 'tooltip.addComment' | translate }}"></i>
            </ng-template>
          </div>
          <div class="form-group display-flex">
            <label>{{ 'editReservationModal.form.contractType' | translate }}</label>
            <div *ngFor="let type of contractTypes" class="form-check">
              <input class="form-check-input" type="radio" [value]="type.id" formControlName="type_contract" [id]="type.id" />
              <label class="form-check-label" [for]="type.id">{{ type.label | translate }}</label><br>
            </div>
          </div>

          <div *ngIf="contractForm.get('type_contract')?.value === commercial">
            <div class="form-group display-ruby">
              <label>{{ 'editReservationModal.form.rateLabel' | translate }}</label>
              <div *ngIf="reservation && reservation.contract && reservation.contract.taux?.length" class="taux-wrapper">
                <div *ngFor="let tauxItem of reservation.contract.taux.slice(0, 5); let i = index" class="taux-input-group">
                  {{ i + 1 }} -
                  <input type="text" class="taux-input input-style" [value]="tauxItem.taux"
                         (change)="updateTaux($event, tauxItem.id_week)"
                         [attr.title]="tauxItem.date_wednesday | date:'dd/MM/yyyy'" maxlength="3" />
                  <label>{{ 'editReservationModal.form.percent' | translate }}</label>
                </div>
                <div *ngIf="reservation.contract.taux.length > 4"  class="show-more-btn">
                  <i class="bi bi-eye-fill btn btn-primary validate-btn"
                     [attr.title]="'editReservationModal.form.viewAllRates' | translate"
                     (click)="openTauxModal()"></i>
                </div>
              </div>
            </div>
            <div class="display-flex">
              <div class="form-group">
                <label>{{ 'editReservationModal.form.mg' | translate }}</label>
                <input class="input-style input-center" id="mg" type="text" size="8" formControlName="minimum"
                       style="margin-right: 5px;">
                <label>{{ 'editReservationModal.form.ht' | translate }}</label>
              </div>
              <div class="form-group display-flex" *ngIf="reservation
                                      && reservation?.is_chorus
                                      && reservation.contract">
                <label for="numero_engagement">{{ 'editReservationModal.form.engagement' | translate }}</label>
                <input type="text" class="form-control input-style engagement-input"
                       formControlName="numero_engagement"
                       id="numero_engagement"/>
              </div>
            </div>
            <div class="display-flex">
              <div class="form-group display-flex">
                <label>{{ 'editReservationModal.form.reservationStatusLabel' | translate }}</label>
                <select class="form-control input-form input-style input-center"
                        formControlName="reservationStatus"
                        (change)="updateReservationState()">
                  <option *ngFor="let status of listStatus" [value]="status.id">{{ status.label }}</option>
                </select>
              </div>
              <div class="form-group display-flex">
                <label  style="margin-left: 5px;">{{ 'editReservationModal.form.copyTypeLabel' | translate }}</label>
                <select class="form-control select-width input-style" formControlName="copyType">
                  <option [selected]="reservation?.reser?.contract?.type_copie?.type === copy.id" *ngFor="let copy of copyTypes" [value]="copy.id">{{ copy.label }}</option>
                </select>
              </div>
            </div>

            <div class="display-flex" style="margin-top: 10px;">
              <div class="form-check adrc">
                <input type="checkbox" class="form-check-input" id="adrc" formControlName="adrc"/>
                <label class="label-style" for="adrc">{{ 'editReservationModal.form.adrc' | translate }}</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="pdc" formControlName="pdc"/>
                <label class="label-style" for="pdc">{{ 'editReservationModal.form.pdc' | translate }}</label>
              </div>
              <div class="form-check display-ruby" *ngIf="contractForm.get('pdc')?.value">
                <label class="cinema-partage label-style" for="selectedCinema">{{ 'editReservationModal.form.selectCinema' | translate }}</label>
                <select formControlName="pdc_reser"
                        class="form-control select-width input-style"
                        [ngStyle]="{ 'color': contractForm.get('pdc_reser')?.value === null ? 'grey' : '' }">
                  <option [ngValue]="null" selected disabled>{{ 'editReservationModal.form.selectCinemaPlaceholder' | translate }}</option>
                  <option *ngFor="let cinema of cinemas" [value]="cinema.id_reser">
                    {{ cinema.liv_ville }} - {{ cinema.nom_cinema }}
                  </option>
                </select>
                <a *ngIf="reservation
                  && reservation.contract
                  && reservation?.contract?.type_copie
                  && Array.isArray(reservation?.contract?.type_copie?.cinema_associe)"
                   (mouseover)="showPopup = true"
                   (mouseleave)="showPopup = false"
                   class="info-icon"
                   style="cursor: pointer; font-size: 0.8rem">{{ 'editReservationModal.form.cinemasList' | translate }}</a>
                <div class="popup" *ngIf="showPopup">
                <ul>
                  <li *ngFor="let item of cinema_associe">{{ item.cinema }}</li>
                </ul>
              </div>
              </div>

            </div>
          </div>

          <div *ngIf="contractForm.get('type_contract')?.value === forfait">
            <div class="display-flex">
              <div class="form-group">
                <label>{{ 'editReservationModal.form.amount' | translate }}</label>
                <input class="input-style" type="text" size="3"  formControlName="forfait" style="margin-right: 5px;">
                <label>{{ 'editReservationModal.form.ht' | translate }}</label>
              </div>

              <div class="form-group display-flex">
                <label>{{ 'editReservationModal.form.tva' | translate }}</label>
                <select class="form-control input-style input-center" formControlName="coef_mult"  style="margin-right: 5px;">
                  <option *ngFor="let item of listTva" [value]="item.id">{{ item.label }}</option>
                </select>
                <label>{{ 'editReservationModal.form.percent' | translate }}</label>
              </div>
             </div>

            <div class="form-group display-flex">
              <label>{{ 'editReservationModal.form.invoice' | translate }}</label>
              <div *ngFor="let type of listTypeFacture">
                <input class="form-check-input" type="radio" [value]="type.id" [id]="type.id" formControlName="invoice_type" />
                <label class="form-check-label" [for]="type.id" >{{ type.label | translate }}</label><br>
              </div>
            </div>
            <div *ngIf="contractForm.get('invoice_type')?.value === 'societe_base'" class="form-group">
              <div class="form-group">
                <input
                       type="text"
                       class="form-control input-style input-facture"
                       [ngbTypeahead]="searchSociete"
                       [inputFormatter]="formatter"
                       [resultFormatter]="formatter"
                       placeholder="{{ 'editReservationModal.form.societePlaceholder' | translate }}"
                       (selectItem)="onFilmSelect($event)"
                />
              </div>
            </div>
            <div *ngIf="contractForm.get('invoice_type')?.value === 'custom'" class="form-group">
              <div class="form-group">
                <label>{{ 'editReservationModal.form.societe' | translate }}</label>
                <input type="text" class="form-control input-style input-facture" formControlName="societe" placeholder="{{ 'editReservationModal.form.societePlaceholder' | translate }}" />
              </div>

              <div class="form-group">
                <label>{{ 'editReservationModal.form.adresse' | translate }}</label>
                <input type="text" class="form-control input-style input-facture" formControlName="adresse" placeholder="{{ 'editReservationModal.form.adressePlaceholder' | translate }}" />
              </div>

              <div class="form-group">
                <label>{{ 'editReservationModal.form.codePostal' | translate }}</label>
                <input type="text" class="form-control input-style input-facture" formControlName="codePostal" placeholder="{{ 'editReservationModal.form.codePostalPlaceholder' | translate }}" />
              </div>

              <div class="form-group">
                <label>{{ 'editReservationModal.form.pays' | translate }}</label>
                <input type="text" class="form-control input-style input-facture" formControlName="pays" placeholder="{{ 'editReservationModal.form.paysPlaceholder' | translate }}" />
              </div>
            </div>

          </div>
          <div class="form-group" *ngIf="reservation && reservation.reser && reservation.reser.heure_avp">
            <label>{{ 'editReservationModal.form.avpTime' | translate }}</label>
            <div class="avp-time-group">
              <input type="number" class="form-control avp-input" formControlName="avpHour" min="0" max="23" placeholder="HH" />
              <span>:</span>
              <input type="number" class="form-control avp-input" formControlName="avpMinute" min="0" max="59" placeholder="MM" />
              <button type="button" class="btn btn-secondary avp-update-btn  validate-btn" (click)="updateTime()">{{ 'editReservationModal.form.updateTime' | translate }}</button>
            </div>
          </div>
          </form>
        </div>
    </div>
  </div>

  <div *ngIf="loading" class="loader">
    <app-progress-spinner></app-progress-spinner>
  </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary validate-btn" (click)="updateContract()">{{ 'editReservationModal.modalFooter.saveButton' | translate }}</button>
</div>


